<mat-toolbar>
  {{ 'SETTINGS.TITLE' | transloco }} {{ authService.getUserEmail() }}
</mat-toolbar>
<div class="container">

  <mat-tab-group dynamicHeight mat-align-tabs="center" class="mt-3">
    <mat-tab [label]="passwordLabels[activeLang]">
      <p class="lead mt-3">
        {{ 'SETTINGS.CHANGE_PASSWORD' | transloco }}
      </p>
      <mat-slide-toggle class="mx-3" [(ngModel)]="showDetails">
        {{ 'SETTINGS.VIEW_PASSWORD_REQUIREMENTS' | transloco }}
      </mat-slide-toggle>

      <form [formGroup]="changePasswordForm">
        <div fxFlex>
          <mat-form-field appearance="outline" class="full-width"> <!-- [color]="passwordComponent.color"> -->
            <mat-label>
              {{ 'SETTINGS.ENTER_CURRENT_PASSWORD' | transloco }}
            </mat-label>
            <mat-pass-toggle-visibility matSuffix></mat-pass-toggle-visibility>
            <input matInput required placeholder="Lösenord" type="password" autocomplete="off"
              formControlName="oldPassword" required>
            @if (changePasswordForm.hasError('required', 'password')) {
            <mat-error>
              {{ 'SETTINGS.CURRENT_PASSWORD_REQUIRED' | transloco }}
            </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width"
            disabled="!this.changePasswordForm.controls.oldPassword.status === 'INVALID'">
            <!-- [color]="passwordComponent.color"> -->
            <mat-label>
              {{ 'SETTINGS.NEW_PASSWORD' | transloco }}
            </mat-label>
            <mat-pass-toggle-visibility matSuffix></mat-pass-toggle-visibility>
            <input matInput #password required placeholder="Nytt lösenord" type="password" autocomplete="off"
              formControlName="newPassword" required>
            @if (changePasswordForm.hasError('required', 'password')) {
            <mat-error>
              {{ 'SETTINGS.NEW_PASSWORD_REQUIRED' | transloco }}
            </mat-error>
            }
            <mat-hint align="end" aria-live="polite">
              {{password.value.length}} / 30 <!-- {{passwordComponent.max}} -->
            </mat-hint>
          </mat-form-field>
          <app-password-strength [passwordToCheck]="changePasswordForm.value.password"
            [showRequirements]="showDetails"></app-password-strength>
        </div>

        <mat-form-field appearance="outline" class="mt-3">
          <mat-label>
            {{ 'SETTINGS.CONFIRM_PASSWORD' | transloco }}
          </mat-label>
          <mat-pass-toggle-visibility matSuffix></mat-pass-toggle-visibility>
          <input matInput placeholder="Bekräfta lösenord" type="password" autocomplete="off"
            formControlName="confirmedPassword" [errorStateMatcher]="matcher">
          <!-- <mat-error *ngIf="changePasswordForm.hasError('notSame') && changePasswordForm.controls['password'].valid">
          Lösenorden stämmer inte överens...
        </mat-error> -->
          @if (changePasswordForm.controls['confirmedPassword'].value !=
          changePasswordForm.controls['newPassword'].value) {
          <mat-error>
            {{ 'SETTINGS.PASSWORDS_DONT_MATCH' | transloco }}
          </mat-error>
          }
        </mat-form-field>

        <button (click)="changePassword()" [disabled]="!changePasswordForm.valid" mat-raised-button color="primary">
          {{ 'SETTINGS.CHANGE_PASSWORD_BUTTON' | transloco }}
        </button>
      </form>

    </mat-tab>
    @if (user?.smsVerification == false) {
    <mat-tab [label]="phoneNumberLabels[activeLang]">
      <p class="lead mt-2">
        {{ 'SETTINGS.ADD_OR_CHANGE_PHONE_NUMBER' | transloco }}
      </p>
      <form [formGroup]="mobileNumberForm">
        @if (phonenumber == '') {
        <div>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SETTINGS.PHONE_NUMBER' | transloco }}
            </mat-label>
            <input matInput placeholder="Ange telefonnummer" formControlName="mobile">
            <mat-icon matSuffix>
              verified_user
            </mat-icon>
          </mat-form-field>
          <button type="button" (click)="changePhoneNumber()" [disabled]="!mobileNumberForm.valid" mat-raised-button
            color="primary">
            {{ 'SETTINGS.ADD_PHONE_NUMBER' | transloco }}
          </button>
        </div>
        }
        @if (phonenumber != '') {
        <div>
          <mat-form-field appearance="outline">
            <mat-label>{{ phonenumber }}</mat-label>
            <input matInput placeholder="Byt telefonnummer" formControlName="mobile">
            <mat-icon class="verified" matSuffix>
              verified_user
            </mat-icon>
          </mat-form-field>
          <button type="button" (click)="changePhoneNumber()" [disabled]="!mobileNumberForm.valid" mat-raised-button
            color="primary">
            {{ 'SETTINGS.CHANGE_PHONE_NUMBER' | transloco }}
          </button>
        </div>
        }
      </form>
    </mat-tab>
    }
  </mat-tab-group>

</div>